import React, { useState } from 'react';
import { Button, Form } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import {
  DisputeCreateMutation,
  DisputeCreateMutationArg,
  DisputeCreateMutationResponse,
} from '@pay-bill/graphql';
import { Drawer } from '@common/components';
import { useDisputeRefetchs } from '@pay-bill/hooks';
import {
  catchFormErrorsWith,
  rejectValidationErrors,
  validationBaseErrorsResponseParser,
} from '@pay-bill/services';
import { ValuesOnFinishType } from '@pay-bill/components';
import { DisputeCreateMissingLineDrawerBody } from './dispute-create-missing-line-drawer-body';

export const DisputeCreateMissingLineDrawer = ({
  open,
  onClose,
  id = '',
}: {
  open: boolean;
  onClose: () => void;
  id?: string;
}) => {
  const [form] = Form.useForm();

  const [loadingBody, setLoadingBody] = useState(false);
  const [baseErrors, setBaseErrors] = useState<null | string>(null);

  const [createDispute, { loading: loadingCreate }] = useMutation<
    DisputeCreateMutationResponse,
    DisputeCreateMutationArg
  >(DisputeCreateMutation);

  const onDrawerClose = () => {
    form.setFieldsValue({
      staffingRequestAssignmentId: undefined,
      newDate: undefined,
      newHours: undefined,
      newPayCode: undefined,
      comment: undefined,
      finalRateCents: undefined,
    });
    onClose();
  };

  const refetchQueries = useDisputeRefetchs();

  const onFinish = async (values: ValuesOnFinishType) => {
    if (loadingCreate) {
      return;
    }

    createDispute({ variables: values })
      .then(rejectValidationErrors('createDispute'))
      .then(() => {
        createMessage('success', 'Dispute has been successfully created!');
        onDrawerClose();
        refetchQueries();
      })
      .catch((response) => {
        const messages = validationBaseErrorsResponseParser(response);
        setBaseErrors(messages);
        catchFormErrorsWith(
          form,
          'Failed to create dispute. Please try again.'
        )(response);
      });
  };

  return (
    <Drawer
      open={open}
      size="sm"
      title="Missing Line Dispute"
      onClose={onDrawerClose}
      className="missing-line-drawer"
      footer={
        <Button
          type="primary"
          size="large"
          onClick={form.submit}
          loading={loadingCreate}
          disabled={loadingBody}
        >
          Send Dispute
        </Button>
      }
    >
      <DisputeCreateMissingLineDrawerBody
        form={form}
        onFinish={onFinish}
        invOrRinvId={id}
        setLoading={setLoadingBody}
        baseErrors={baseErrors}
      />
    </Drawer>
  );
};
